var map = {
	"./components/pages/assessmanagement/assessmanagement.api.js": 46019,
	"./components/pages/attendancemanagement/attendance.api.js": 64165,
	"./components/pages/businesstoconsumerconfig/businesstoconsumerconfig.api.js": 66091,
	"./components/pages/career/career.api.js": 91416,
	"./components/pages/category/category.api.js": 38734,
	"./components/pages/configureassessmentparameter/configureassessmentparameter.api.js": 71829,
	"./components/pages/contentmanagement/contentmanagement.api.js": 8329,
	"./components/pages/employeemanagement/employeemanagement.api.js": 5962,
	"./components/pages/enquires/enquire.api.js": 1240,
	"./components/pages/gallerymanagement/gallerymanagement.api.js": 71101,
	"./components/pages/invoiceform/invoiceform.api.js": 25245,
	"./components/pages/maintenancetracker/maintenancetracker.api.js": 46444,
	"./components/pages/schedulemanagement/event.api.js": 50047,
	"./components/pages/schooladmin/classmanagement/classmanagement.api.js": 55556,
	"./components/pages/schoolinframaintenancetracker/schoolinframaintenancetracker.api.js": 45510,
	"./components/pages/schoolmanagement/schoolmanagement.api.js": 38344,
	"./components/pages/taskmanagement/task.api.js": 73597
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 86758;